import React from "react";
import ThirdContentWeb from "../../../images/LandingPage/Contents/Process3/Content-3.webm";
import ThirdContentMp from "../../../images/LandingPage/Contents/Process3/Content-3.mp4";

const ThirdContentProcess = () => {
  return (
    <>
      <video
        loading="lazy"
        autoPlay
        muted
        loop
        playsInline
        style={{
          justifySelf: "center",
          maxWidth: 400,
          width: "100%",
          height: "auto",
          borderRadius: 4,
        }}
      >
        <source src={ThirdContentWeb} type="video/webm" />
        <source src={ThirdContentMp} type="video/mp4" />
      </video>
    </>
  );
};

export default ThirdContentProcess;
